// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/BasisGrotesquePro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/BasisGrotesquePro-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/BasisGrotesquePro-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Basis Grotesque";
  font-style: normal;
  font-weight: normal;
  src: local("Basis Grotesque"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}
@font-face {
  font-family: "Basis Grotesque Bold";
  font-style: normal;
  font-weight: normal;
  src: local("Basis Grotesque Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "Basis Grotesque Light";
  font-style: normal;
  font-weight: normal;
  src: local("Basis Grotesque Light"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}
* {
  box-sizing: border-box;
  font-family: Basis Grotesque, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 1.3;
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,qFAAA;AACD;AAGA;EACC,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0FAAA;AADD;AAIA;EACC,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2FAAA;AAFD;AAKA;EACC,sBAAA;EACA,mDAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;AAHD;;AAMA;EACC,SAAA;AAHD","sourcesContent":["@font-face {\n\tfont-family: \"Basis Grotesque\";\n\tfont-style: normal;\n\tfont-weight: normal;\n\tsrc: local(\"Basis Grotesque\"), url(\"fonts/BasisGrotesquePro-Regular.woff\") format(\"woff\");\n\t\n}\n\n@font-face {\n\tfont-family: \"Basis Grotesque Bold\";\n\tfont-style: normal;\n\tfont-weight: normal;\n\tsrc: local(\"Basis Grotesque Bold\"), url(\"fonts/BasisGrotesquePro-Bold.woff\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: \"Basis Grotesque Light\";\n\tfont-style: normal;\n\tfont-weight: normal;\n\tsrc: local(\"Basis Grotesque Light\"), url('fonts/BasisGrotesquePro-Light.woff') format(\"woff\");\n}\n\n* {\n\tbox-sizing: border-box;\n\tfont-family: Basis Grotesque, Helvetica, sans-serif;\n\tfont-size: 1rem;\n\tline-height: 1.3;\n\t-webkit-tap-highlight-color: transparent;\n}\n\nbody {\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
